

export default function initAccordeons(): void {
    const $accordeonsContainer = document.querySelectorAll<HTMLElement>('.accordeon');

    $accordeonsContainer.forEach($container => {
        new AccordeonsContainer($container);
    });
}

class AccordeonsContainer {
    $el: HTMLElement | null | undefined;
    $accordeonsWrapper: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$accordeonsWrapper = $el?.querySelector('.accordeons-wrapper');
        this.init();
    }

    init(): void {
        const firstDropdown = this.$accordeonsWrapper?.querySelector('.accordeon-item') as HTMLDetailsElement

        firstDropdown.open = true;
    }

    
}
